import './index.svelte.css.proxy.js';
/* src/routes/index.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Nav from "../../_components/navigation/Nav.svelte.js";
import MainVisual from "../../_components/index/MainVisual.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Columns from "../../_components/column/Columns.svelte.js";
import Column from "../../_components/column/Column.svelte.js";
import ImageLink from "../../_components/button/ImageLink.svelte.js";

function create_default_slot_17(ctx) {
	let imagelink;
	let current;

	imagelink = new ImageLink({
			props: {
				href: "recruit",
				src: "images/top-04.jpg",
				srcset: "images/top-04-sp.jpg 768w, images/top-04.jpg",
				loading: "lazy"
			}
		});

	return {
		c() {
			create_component(imagelink.$$.fragment);
		},
		l(nodes) {
			claim_component(imagelink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(imagelink, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(imagelink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(imagelink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(imagelink, detaching);
		}
	};
}

// (25:2) <Wrap>
function create_default_slot_16(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 1) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (24:0) <Section kind="top">
function create_default_slot_15(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 1) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (39:4) <Inner>
function create_default_slot_14(ctx) {
	let h2;
	let img;
	let img_src_value;

	return {
		c() {
			h2 = element("h2");
			img = element("img");
			this.h();
		},
		l(nodes) {
			h2 = claim_element(nodes, "H2", {});
			var h2_nodes = children(h2);
			img = claim_element(h2_nodes, "IMG", { src: true, srcset: true, alt: true });
			h2_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "images/index-heading-1.png")) attr(img, "src", img_src_value);
			attr(img, "srcset", "images/index-heading-1-sp.png 768w, images/index-heading-1.png");
			attr(img, "alt", "軽から普通、大型・特殊まで、あらゆる整備ニーズに誠実に対応いたします。");
		},
		m(target, anchor) {
			insert(target, h2, anchor);
			append(h2, img);
		},
		d(detaching) {
			if (detaching) detach(h2);
		}
	};
}

// (38:2) <Wrap>
function create_default_slot_13(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 1) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (37:0) <Section kind="top">
function create_default_slot_12(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 1) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (55:8) <Column columns="2" space="wide">
function create_default_slot_11(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", {});
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "images/top-05.jpg")) attr(img, "src", img_src_value);
			attr(img, "alt", "1964年の創業から地元密着で自動車王国・群馬を支えてきました");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (60:8) <Column columns="2" space="wide">
function create_default_slot_10(ctx) {
	let div;
	let h3;
	let t0;
	let t1;
	let p;
	let t2;

	return {
		c() {
			div = element("div");
			h3 = element("h3");
			t0 = text("1964年の創業から地元密着で自動車王国・群馬を支えてきました");
			t1 = space();
			p = element("p");
			t2 = text("世帯あたりの自動車保有台数が全国トップクラスの群馬県。1964年の創業から自動車整備のプロ集団として、そうした自動車王国の一端を担い、軽から普通、大型・特殊まで、あらゆる整備ニーズに対応してきました。");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			h3 = claim_element(div_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t0 = claim_text(h3_nodes, "1964年の創業から地元密着で自動車王国・群馬を支えてきました");
			h3_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p = claim_element(div_nodes, "P", { class: true });
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "世帯あたりの自動車保有台数が全国トップクラスの群馬県。1964年の創業から自動車整備のプロ集団として、そうした自動車王国の一端を担い、軽から普通、大型・特殊まで、あらゆる整備ニーズに対応してきました。");
			p_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h3, "class", "svelte-t8t83d");
			attr(p, "class", "svelte-t8t83d");
			attr(div, "class", "content svelte-t8t83d");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h3);
			append(h3, t0);
			append(div, t1);
			append(div, p);
			append(p, t2);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (54:6) <Columns space="wide">
function create_default_slot_9(ctx) {
	let column0;
	let t;
	let column1;
	let current;

	column0 = new Column({
			props: {
				columns: "2",
				space: "wide",
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	column1 = new Column({
			props: {
				columns: "2",
				space: "wide",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(column0.$$.fragment);
			t = space();
			create_component(column1.$$.fragment);
		},
		l(nodes) {
			claim_component(column0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(column1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(column0, target, anchor);
			insert(target, t, anchor);
			mount_component(column1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const column0_changes = {};

			if (dirty & /*$$scope*/ 1) {
				column0_changes.$$scope = { dirty, ctx };
			}

			column0.$set(column0_changes);
			const column1_changes = {};

			if (dirty & /*$$scope*/ 1) {
				column1_changes.$$scope = { dirty, ctx };
			}

			column1.$set(column1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(column0.$$.fragment, local);
			transition_in(column1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(column0.$$.fragment, local);
			transition_out(column1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(column0, detaching);
			if (detaching) detach(t);
			destroy_component(column1, detaching);
		}
	};
}

// (53:4) <Inner>
function create_default_slot_8(ctx) {
	let columns;
	let current;

	columns = new Columns({
			props: {
				space: "wide",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(columns.$$.fragment);
		},
		l(nodes) {
			claim_component(columns.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(columns, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const columns_changes = {};

			if (dirty & /*$$scope*/ 1) {
				columns_changes.$$scope = { dirty, ctx };
			}

			columns.$set(columns_changes);
		},
		i(local) {
			if (current) return;
			transition_in(columns.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(columns.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(columns, detaching);
		}
	};
}

// (52:2) <Wrap>
function create_default_slot_7(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 1) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (51:0) <Section kind="top">
function create_default_slot_6(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 1) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (75:8) <Column columns="2" space="wide">
function create_default_slot_5(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", {});
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "images/top-06.jpg")) attr(img, "src", img_src_value);
			attr(img, "alt", "");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (80:8) <Column columns="2" space="wide">
function create_default_slot_4(ctx) {
	let div;
	let h3;
	let t0;
	let t1;
	let p;
	let t2;

	return {
		c() {
			div = element("div");
			h3 = element("h3");
			t0 = text("高所作業車の指定サービス工場として卓越した整備技術を誇っています。");
			t1 = space();
			p = element("p");
			t2 = text("高所作業車の製造で全国トップのシェアを持つアイチコポーレーション。その指定サービス工場になっていることから、特殊車両の整備においてもプロフェッショナルの高い技術力を発揮しています。");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			h3 = claim_element(div_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t0 = claim_text(h3_nodes, "高所作業車の指定サービス工場として卓越した整備技術を誇っています。");
			h3_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p = claim_element(div_nodes, "P", { class: true });
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "高所作業車の製造で全国トップのシェアを持つアイチコポーレーション。その指定サービス工場になっていることから、特殊車両の整備においてもプロフェッショナルの高い技術力を発揮しています。");
			p_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h3, "class", "svelte-t8t83d");
			attr(p, "class", "svelte-t8t83d");
			attr(div, "class", "content svelte-t8t83d");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, h3);
			append(h3, t0);
			append(div, t1);
			append(div, p);
			append(p, t2);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (74:6) <Columns space="wide">
function create_default_slot_3(ctx) {
	let column0;
	let t;
	let column1;
	let current;

	column0 = new Column({
			props: {
				columns: "2",
				space: "wide",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	column1 = new Column({
			props: {
				columns: "2",
				space: "wide",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(column0.$$.fragment);
			t = space();
			create_component(column1.$$.fragment);
		},
		l(nodes) {
			claim_component(column0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(column1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(column0, target, anchor);
			insert(target, t, anchor);
			mount_component(column1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const column0_changes = {};

			if (dirty & /*$$scope*/ 1) {
				column0_changes.$$scope = { dirty, ctx };
			}

			column0.$set(column0_changes);
			const column1_changes = {};

			if (dirty & /*$$scope*/ 1) {
				column1_changes.$$scope = { dirty, ctx };
			}

			column1.$set(column1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(column0.$$.fragment, local);
			transition_in(column1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(column0.$$.fragment, local);
			transition_out(column1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(column0, detaching);
			if (detaching) detach(t);
			destroy_component(column1, detaching);
		}
	};
}

// (73:4) <Inner>
function create_default_slot_2(ctx) {
	let columns;
	let current;

	columns = new Columns({
			props: {
				space: "wide",
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(columns.$$.fragment);
		},
		l(nodes) {
			claim_component(columns.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(columns, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const columns_changes = {};

			if (dirty & /*$$scope*/ 1) {
				columns_changes.$$scope = { dirty, ctx };
			}

			columns.$set(columns_changes);
		},
		i(local) {
			if (current) return;
			transition_in(columns.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(columns.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(columns, detaching);
		}
	};
}

// (72:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 1) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (71:0) <Section>
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 1) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let nav;
	let t1;
	let mainvisual;
	let t2;
	let section0;
	let t3;
	let section1;
	let t4;
	let section2;
	let t5;
	let section3;
	let current;
	nav = new Nav({ props: { segment: "home" } });
	mainvisual = new MainVisual({});

	section0 = new Section({
			props: {
				kind: "top",
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "top",
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				kind: "top",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(nav.$$.fragment);
			t1 = space();
			create_component(mainvisual.$$.fragment);
			t2 = space();
			create_component(section0.$$.fragment);
			t3 = space();
			create_component(section1.$$.fragment);
			t4 = space();
			create_component(section2.$$.fragment);
			t5 = space();
			create_component(section3.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-vdw5ds\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(mainvisual.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(section0.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(section2.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(section3.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:type");
			attr(meta3, "content", "website");
			attr(meta4, "property", "og:description");
			attr(meta4, "content", "私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(nav, target, anchor);
			insert(target, t1, anchor);
			mount_component(mainvisual, target, anchor);
			insert(target, t2, anchor);
			mount_component(section0, target, anchor);
			insert(target, t3, anchor);
			mount_component(section1, target, anchor);
			insert(target, t4, anchor);
			mount_component(section2, target, anchor);
			insert(target, t5, anchor);
			mount_component(section3, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 1) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 1) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 1) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 1) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(mainvisual.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(mainvisual.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(nav, detaching);
			if (detaching) detach(t1);
			destroy_component(mainvisual, detaching);
			if (detaching) detach(t2);
			destroy_component(section0, detaching);
			if (detaching) detach(t3);
			destroy_component(section1, detaching);
			if (detaching) detach(t4);
			destroy_component(section2, detaching);
			if (detaching) detach(t5);
			destroy_component(section3, detaching);
		}
	};
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Routes;
//# sourceMappingURL=index.svelte.js.map
